<template lang="html">
    <gcmcn-layout
        title="ALL TAKERS"
        custom-class="taker-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="onTakerCreate"
        >
            Add taker
        </el-button>
        <ns-loader
            ref="ns-loader-root"
            :toLoad="toLoadRoot"
            @dataFetched="onDataFetchedRoot"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <div slot="content">
                <el-row :gutter="20" class="main-content">
                    <el-col
                        :span="12"
                        :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                        style="overflow: auto;"
                    >
                        <takerList
                            @changeSelectedTaker="changeSelectedTaker"
                            :selected-taker-uid="selectedTakerUid"
                        ></takerList>
                    </el-col>
                    <el-col :span="12" :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}" style="overflow: auto;" >

                        <taker-form
                            v-if="displayFormView"
                            :taker-uid="selectedTakerUid"
                            :takers-with-id="takersWithId"
                            @on-taker-created="OnTakerCreated"
                            @leave-form-view="onLeaveTakerForm"
                        ></taker-form>
                        <el-tabs
                            v-else-if="selectedTakerUid"
                            class="gcmcn-tabs"
                            style="margin-top: 30px;"
                            v-model="activeName"
                            :key="selectedTakerUid"
                        >
                            <el-tab-pane label="Details" name="details">
                                <div class="gcmcn-card-gradient">
                                    <takerDetails
                                        :takerUid="selectedTakerUid"
                                        :kickTakerRequests="kickTakerRequests"
                                        @unselectTaker="unselectTaker"
                                        @editTaker="onTakerUpdate"
                                    ></takerDetails>
                                    <el-divider></el-divider>
                                    <ns-loader
                                        v-if="nowUtc"
                                        ref="ns-loader"
                                        :toLoad="toLoad"
                                        @dataFetched="onDataFetched"
                                    >
                                        <ns-loader-spinner slot="loader"></ns-loader-spinner>
                                        <div slot="content">
                                            <takerRelatedFeedsList
                                                ref="feed-list"
                                                :takerUid="selectedTakerUid"
                                                :feeds-for-taker-with-broadcast-right="feedsForTakerWithBroadcastRight"
                                                :broadcast-rights="broadcastRights"
                                                :events="events"
                                                @fetch-broadcastrights="fetchBroadcastrights"
                                            ></takerRelatedFeedsList>
                                        </div>
                                    </ns-loader>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Users" name="users">
                                <takerRelatedUserList :takerUid="selectedTakerUid"></takerRelatedUserList>
                            </el-tab-pane>
                        </el-tabs>
                        <div v-else class="list-empty" style="margin-top: 40px;">Please select a taker</div>
                    </el-col>
                </el-row>
            </div>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>

import takerList from './takerList.vue';
import takerDetails from './takerDetails.vue';
import takerRelatedUserList from './takerRelatedUserList.vue';
import takerRelatedFeedsList from './takerRelatedFeedsList.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import TakerForm from './taker-form.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        takerList,
        takerDetails,
        takerRelatedUserList,
        takerRelatedFeedsList,
        TakerForm,
        NsLoader,
        NsLoaderSpinner,
        GcmcnLayout,
    },
    data () {
        return {
            activeName: 'details',
            selectedTakerUid: '',
            feedsUid: [],
            feeds: [],
            broadcastRights: [],
            events: [],
            displayFormView: false,
            kickTakerRequests: [],
        };
    },
    computed: {
        ...mapGetters([
            'takers',
        ]),
        nowUtc (){
            return this.$store.state.nowUtc;
        },
        toLoadRoot() {
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
            ]
        },
        toLoad() {
            return [
                {
                    name: 'broadcastRights',
                    model: 'broadcastRight',
                    filters: {
                        archived: false,
                        revoked: false,
                    }
                },
                {
                    name: 'kickTakerRequests',
                    model: 'kickTakerRequests',
                    filters: {
                        taker_uid: this.selectedTakerUid,
                        status__in: ['PENDING', 'DELETING']
                    }
                },
            ];
        },
        feedsForTakerWithBroadcastRight (){
            return this.feeds.filter((feed) => {
                return this.feedsUid.includes(feed.uid);
            });
        },
        takersWithId(){
            return this.takers.filter(taker => taker.client_identifier !== '');
        }
    },
    mounted() {
    },

    watch: {
        '$route': {
            handler (route){
                if(route.params.takerUid){
                    this.selectedTakerUid = route.params.takerUid;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        unselectTaker() {
            this.selectedTakerUid = '';
        },
        changeSelectedTaker(uid) {
            if(this.displayFormView) this.displayFormView = false;
            this.selectedTakerUid = uid;
        },
        onTakerCreate() {
            this.selectedTakerUid = '';
            this.displayFormView = true;
        },
        onTakerUpdate() {
            this.displayFormView = true;
        },
        onDataFetchedRoot(results) {
            this.$set(this, 'feeds', results.feeds);
            this.$set(this, 'events', results.events);
        },
        onDataFetched(results) {
            this.$set(this, 'broadcastRights', results.broadcastRights);
            this.$set(this, 'kickTakerRequests', results.kickTakerRequests);
            let feedsUid = results.broadcastRights.filter(broadcastRight => {
                return broadcastRight.taker_uid === this.selectedTakerUid;
            }).map(broadcastRight => {
                return broadcastRight.feed_uid;
            });
            this.$set(this, 'feedsUid', feedsUid);
        },
        fetchBroadcastrights (){
            this.$refs['ns-loader'].triggerRefresh().then(() => {
                this.$eventBus.$emit('broadcast-right-save-ended');
            });
        },
        OnTakerCreated (){
            this.$store.dispatch('fetchModelByName', 'groups');
            this.onLeaveTakerForm();
        },
        onLeaveTakerForm (){
            this.displayFormView = false;
        },
    }
};
</script>

<style lang="scss">
.taker-view {
    padding-bottom: 0 !important;
    background-color: #333;
    .header-row {
        display: flex;
        align-items: center;;
        justify-content: space-between;
    }
    .takers-title {
        color: #AAA;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/index.vue